export default {
  'Submit': 'Enviar',
  'Save': 'Salvar',
  'enterOTP': 'Digite o código de verificação',
  'otpSent': 'Código de Verificação enviado',
  'login/signup': 'Entrar / Inscrever-se',
  'resendCode': 'Reenviar código',
  'edit': 'Editar',
  'otpMessage': 'Um código de 6 dígitos foi enviado para o seu número de celular',
  'oyo360WelcomeMessage': 'Entrar / Inscrever-se',
  'oyo360ResendCode': 'Reenviar código',
  'oyo360Edit': 'Editar',
  'oyo360otpMessage': 'Um código de 6 dígitos foi enviado para o seu número de celular',
  'buttonActionContinue': 'Continuar',
  'chooseLanguage': 'Escolha um idioma',
  'currentLanguage': 'Idioma atual',
  'otherLanguages': 'Outros idiomas',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'ou ',
  'buttonActionSubmit': 'Enviar',
  'welcomeTitle': 'Bem-vindo a OYO',
  'welcomeHeadingForMailLogin': 'Digite o endereço de e-mail registrado associado a nós',
  'welcomeHeadingForPhoneLogin': 'Insira o número do celular registrado associado a nós',
  'welcomeHeadingForLogin': 'Digite o endereço de e-mail registrado/número de telefone conosco',
  'userNameLabel': 'Seu e-mail/número de telefone',
  'userNameErrorMessage':'Insira o seu de e-mail/número de telefone correto',
  'emailIdLabel': 'Identificação do email',
  'phoneNumberLabel': 'Número de telefone ',
  'passwordLabel': 'Senha',
  'newPasswordLabel': 'Nova Senha',
  'confirmNewPasswordLabel': 'Confirmar Nova Senha',
  'emailErrorMessage': 'Insira o e-mail correto',
  'phoneNumberErrorMessage': 'Por favor, insira o número de telefone correto',
  'passwordErrorMessage': 'Por favor, digite a senha correta',
  'confirmPasswordErrorMessage': 'A senha não corresponde!',
  'generateNewPassword': 'Gere uma nova senha',
  'loginButtonLabel': 'Conecte-se',
  'loginWithPhoneButtonLabel': 'Continue com o telefone',
  'loginWithOtp': 'Em vez disso, faça login com o  código de verificação',
  'loginWithEmailButtonLabel': 'Continue com o e-mail',
  'back': 'Voltar',
  'loginWithOtpTitle': 'Digite o código de verificação',
  'loginWithOtpHeading': 'Você receberá o OTP se o número de telefone estiver registrado em nosso sistema',
  'listYourProperty': 'Liste sua propriedade',
  'privacyPolicy': 'política de privacidade',
  'verifyEmail': 'Verifique o endereço de e-mail',
  'verifyMobile': 'Verifique o número do celular',
  'forgotPasswordPhoneSubHeading': 'Enviaremos a você um código de 6 dígitos para verificar o seu número de telefone',
  'forgotPasswordMailSubHeading': 'Iremos enviar-lhe um código de 6 dígitos para verificar o seu e-mail',
  'newPasswordCondition1': 'Deve ter número e símbolo',
  'newPasswordCondition2': 'Deve ter pelo menos 8 caracteres',
  'newPasswordCondition3': 'Deve ter letras maiúsculas e minúsculas',
  'confirmLogin': 'Confirmar e fazer login',
  'getOTP': 'Obtenha código de verificação',
  'invalidInput': 'informação inválida',
  'passwordResetMessage': 'Senha criada com sucesso',
  'otpErrorMessage': 'Por favor, insira o código de verificação correto',
  'resendOtpSuccessMessage': 'Código de verificação foi reenviado para o seu número de celular com sucesso',
  'InternalServerErrorMessage': 'Erro interno do Servidor ',
  'resetPasswordHeading': 'Um código de 6 dígitos foi enviado para seu e-mail e número de telefone',
  'signingIn': 'Entrando',
  'invalidMobileNumber': 'Número de celular inválido',
  'privacyFooterText': 'Ao fazer login em sua conta, você aceita nossos {termsOfUse} e {privacyPolicy}',
  'and': 'e',
  'termsOfUse': 'termos de uso',
  'listProperty': 'Liste sua propriedade',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': 'Voc\u00ea n\u00e3o tem hot\u00e9is associados',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'Você será desconectado de todos os dispositivos após alterar sua senha'
};
